import { CONST } from '@common/constants/const.constant';
import dayjs from 'dayjs';
import { dayjsEx } from '@common/utils/dayjs-ex.util';
import { isCypress } from '@common/utils//is-cypress.util';

// dayjs fails in the tests
export const formatDate = (date: number | string | Date | undefined): string => {
    if (!date) {
        return 'Invalid date';
    }
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();

    // dayjs fails in the tests
    // return dayjs(date).format('YYYY-MM-DD');
    return [year, month.length < 2 ? '0' + month : month, day.length < 2 ? '0' + day : day].join('-');
};

export const formatDateWithDayOfWeek = (date: Date | undefined): string => {
    if (!date) {
        return '';
    }
    return dayjsEx(date).format('dddd, Do MMMM YYYY');
};

export const formatDateWithAbbreviation = (date: Date | undefined): string => {
    if (!date) {
        return '';
    }
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'short' as 'short' | 'long' | 'narrow' | undefined,
        month: 'short' as 'short' | 'long' | 'narrow' | undefined,
        day: 'numeric',
        year: 'numeric',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const formatDateCustomFormat = (date: Date | undefined, dateFormat: string | undefined): string => {
    if (!date || !dateFormat) {
        return '';
    }
    return dayjsEx(date).format(dateFormat);
};

export const formatDateTimeWithHours = (date: Date | undefined): string => {
    if (!date) {
        return '';
    }
    return dayjsEx(date).format('dddd, Do MMMM YYYY, hh:mma');
};

export const toServerDate = (date: Date | undefined): string => {
    return dayjsEx(date).format(CONST.SERVER_DATE_FORMAT);
};

export const toServerTime = (date: Date | undefined): string => {
    if (!date) {
        return 'invlid date';
    }
    if (!isCypress()) {
        return (dayjsEx(date) as unknown as { utc: () => dayjs.Dayjs }).utc().format('HH:mm');
    }
    const hours = '0' + date.getUTCHours();
    const minutes = '0' + date.getUTCMinutes();
    return `${hours.substring(hours.length - 2)}:${minutes.substring(minutes.length - 2)}`;
};

export const formatTime = (date: Date | undefined): string => {
    return dayjs(date).format('hh:mma');
};
